import { render } from "./table1.vue?vue&type=template&id=42e666e2&scoped=true"
import script from "./table1.vue?vue&type=script&lang=js"
export * from "./table1.vue?vue&type=script&lang=js"

import "./table1.vue?vue&type=style&index=0&id=42e666e2&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e666e2"]])

export default __exports__